export default "__VITE_ASSET__DSXgO47j__"